import { render, staticRenderFns } from "./VoucherStatistic.vue?vue&type=template&id=194cf005&scoped=true"
import script from "./VoucherStatistic.vue?vue&type=script&lang=js"
export * from "./VoucherStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194cf005",
  null
  
)

export default component.exports